var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9C19.5 7.76808 19.4536 6.54699 19.3624 5.3384C19.2128 3.35425 17.6458 1.78724 15.6616 1.63757C14.453 1.54641 13.2319 1.5 12 1.5C10.7681 1.5 9.54699 1.54641 8.3384 1.63757C6.35425 1.78724 4.78724 3.35425 4.63757 5.3384C4.62097 5.55852 4.60585 5.77906 4.59222 6M19.5 9L22.5 6M19.5 9L16.5 6M4.5 9C4.5 10.2319 4.54641 11.453 4.63757 12.6616C4.78724 14.6458 6.35425 16.2128 8.3384 16.3624C9.54699 16.4536 10.7681 16.5 12 16.5C13.2319 16.5 14.453 16.4536 15.6616 16.3624C17.6458 16.2128 19.2128 14.6458 19.3624 12.6616C19.379 12.4415 19.3941 12.2209 19.4078 12M4.5 9L7.5 12M4.5 9L1.5 12",
    stroke: "#001F68",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.9bc83636c7a2a17f675e42017a8cd245.svg";
export { ForwardRef as ReactComponent };